// facts.ts — Patch 010.A.4 R7 split. Project facts CRUD + lifecycle.
// Step 1e — facts insights (downstream consumers + what's missing).

import { request } from './request'
import type { FactRow, UpsertFactInput } from './types'

export interface FactConsumer {
  count: number
  labels: string[]
}

export interface FactInsightsResponse {
  ok: true
  consumers: Record<string, FactConsumer>
  missing: string[]
  referenced_count: number
  present_count: number
}

export interface FactContradiction {
  rule_id: string
  title: string
  facts: string[]
  message: string
  resolution: string
  facts_read: Record<string, unknown>
}

export const factsApi = {
  list: (projectId: string) =>
    request<{ ok: true; facts: FactRow[] }>(
      `/api/projects/${encodeURIComponent(projectId)}/facts`,
    ),
  contradictions: (projectId: string) =>
    request<{ ok: true; count: number; contradictions: FactContradiction[] }>(
      `/api/projects/${encodeURIComponent(projectId)}/fact-contradictions`,
    ),
  insights: (projectId: string) =>
    request<FactInsightsResponse>(
      `/api/projects/${encodeURIComponent(projectId)}/facts/insights`,
    ),
  upsert: (projectId: string, body: UpsertFactInput) =>
    request<{ ok: true; fact: FactRow; outcome: 'inserted' | 'updated' }>(
      `/api/projects/${encodeURIComponent(projectId)}/facts`,
      { method: 'POST', body: JSON.stringify(body) },
    ),
  valueEdit: (projectId: string, factKey: string, body: Partial<UpsertFactInput>) =>
    request<{ ok: true; fact: FactRow; outcome: 'inserted' | 'updated' }>(
      `/api/projects/${encodeURIComponent(projectId)}/facts/${encodeURIComponent(factKey)}`,
      { method: 'PATCH', body: JSON.stringify(body) },
    ),
  review: (projectId: string, factKey: string) =>
    request<{ ok: true }>(
      `/api/projects/${encodeURIComponent(projectId)}/facts/${encodeURIComponent(factKey)}/review`,
      { method: 'POST' },
    ),
  lock: (projectId: string, factKey: string) =>
    request<{ ok: true }>(
      `/api/projects/${encodeURIComponent(projectId)}/facts/${encodeURIComponent(factKey)}/lock`,
      { method: 'POST' },
    ),
  unlock: (projectId: string, factKey: string) =>
    request<{ ok: true }>(
      `/api/projects/${encodeURIComponent(projectId)}/facts/${encodeURIComponent(factKey)}/unlock`,
      { method: 'POST' },
    ),
}
